import type React from 'react';

import { memo } from 'react';

export const CloseIcon = memo(function CloseIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
      </g>
    </svg>
  );
});
